import { ArrowRightIcon } from '@heroicons/react/20/solid';
import {
  CompleteServiceExecutionFragment,
  GetCheckedInStylistsDocument,
  GetServiceExecutionsDocument,
  useHoldServiceMutation,
} from 'drycut-graphql';
import { Button, Stack } from 'ui-components';
import HoldConfirmation from './HoldConfirmation';
import { useBoolean } from 'usehooks-ts';

type Props = {
  serviceExecution: CompleteServiceExecutionFragment;
  disabled?: boolean;
};

export default function HoldServiceButton({
  serviceExecution,
  disabled,
}: Props): React.ReactElement {
  const [holdService, { loading }] = useHoldServiceMutation();
  const { value: confirmOpen, toggle: toggleConfirmOpen } = useBoolean(false);

  const handleConfirm = async () => {
    toggleConfirmOpen();

    await holdService({
      variables: {
        input: {
          serviceExecutionId: serviceExecution.id,
        },
      },

      // The hold action may affect who got what service execution, so we need to refetch the
      // checked-in stylists. We also refetch all the service executions because putting a service
      // on hold will change the state of other service executions.
      refetchQueries: [GetCheckedInStylistsDocument, GetServiceExecutionsDocument],
    });
  };

  return (
    <>
      <Button
        size="small"
        className="min-w-12 max-w-32"
        textClassName="p-0 text-nowrap text-ellipsis overflow-hidden"
        loading={loading}
        onClick={toggleConfirmOpen}
        disabled={disabled}
      >
        {!loading && (
          <Stack direction="row" gap={1}>
            <span className="sm:hidden xl:flex">No Show</span>

            <ArrowRightIcon className="w-4 h-4" />
          </Stack>
        )}
      </Button>

      <HoldConfirmation open={confirmOpen} onClose={toggleConfirmOpen} onConfirm={handleConfirm} />
    </>
  );
}
